export const cartasLotería = [  
  {  
    id: 1,  
    descripcion: "Dip. Juan Zepeda Hernández",  
    speak_text: "El gallo",  
    image_url: "https://cdn.abacus.ai/images/d163e019-f299-474c-af28-2b265d2f7ac9.jpg"  
  },  
  {  
    id: 2,  
    descripcion: "Lic. Juana Bonilla Jaime",  
    speak_text: "La cordinadora",  
    image_url: "https://cdn.abacus.ai/images/135cf746-3ae1-474c-abc1-2ffdad20b105.jpg"  
  },  
  {  
    id: 3,  
    descripcion: "Dr. David Vazquez",  
    speak_text: "Texcoco",  
    image_url: "https://cdn.abacus.ai/images/46f0f0b7-606b-46e6-a99c-2fd4ecf10f29.jpg"  
  },  
  {  
    id: 4,  
    descripcion: "Lic. Joel Nahun Pineda Diaz",  
    speak_text: "Acolman",  
    image_url: "https://cdn.abacus.ai/images/0019074a-7286-4df4-bd24-d6b4fa5792d0.jpg"  
  },  
  {  
    id: 5,  
    descripcion: "Mtro. Israel Ramirez Castañeda",  
    speak_text: "Trabajadores y Productores",  
    image_url: "https://cdn.abacus.ai/images/b290baa5-a832-46be-b081-4cbfc828f10c.jpg"  
  }  
];